<template>
  <el-dialog
    :title="$t('lang.audioAutoplayPolicy')"
    :visible.sync="audioAutoplay.show"
    width="600px"
    center
    :show-close='false'
    :close-on-press-escape='false'
    :close-on-click-modal='false'
    :append-to-body='true'>
    <div slot="title" class="header-title"> <i class="iconfont icon-warning"></i> <span>{{$t('lang.audioAutoplayPolicy')}}</span> </div>
    <div class="content">
      {{$t('lang.audioAutoplayPolicyText')}}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" class="saveButton" @click="allow">{{ $t("lang.allow") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    audioAutoplay: {
      type: Object
    }
  },
  methods: {
    allow () {
      this.$emit('openAudio')
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep.el-dialog__wrapper{
  .el-dialog {
    padding: 30px 20px 0;
  }
  .el-dialog__header{
    height: 45px !important;
    line-height: 45px !important;
    border-bottom: none!important;
    .header-title{
      display: flex;
      span {
        color: #FFF;
        font-size: 20px;
        margin-left: 5px;
      }
      i {
        color: #FFC573;
        font-size: 20px;
        margin-top: 2px;
      }
    }
  }
  .el-dialog__body{
    padding: 10px 10px 10px 22px;
    .content{
      color: #979da3;
      word-break: break-word;
      word-wrap: break-word;
      font-weight: 600;
      font-size: 14px;
    }
  }
  .el-dialog__footer{
    text-align: right;
    padding: 15px 32px 40px!important;
    .saveButton {
      padding: 9px 20px;
    }
  }
}
</style>
